/* Imports */
import React, { useState } from "react"
import { Grid, Input } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"
import DemoItem from "../../components/DemoItem"

import commonProps from "../../data/common-props"

const InputPage = () => {
    const [inputs, setInputs] = useState({
        text: "",
        textDisabled: "",
        textValidate: "",
        textIcon: "",
        helpers: "",
        counter: "",
        password: "Password",
        passwordIcon: "Password",
        file: "",
        fileDisabled: "",
        url: "",
        calendar: "",
        calendarLocal: "",
        time: "",
        searchEmpty: "",
        search: "Search",
        select: "option",
        textarea: "",
        textareaDisabled: "",
    })

    const handleInputs = e =>
        setInputs({
            ...inputs,
            [e.target.id]: e.target.value,
        })

    const clearSearch = () =>
        setInputs({
            ...inputs,
            search: "",
        })

    const clearSearchEmpty = () =>
        setInputs({
            ...inputs,
            searchEmpty: "",
        })

    const [validation, setValidation] = useState("not-passed")
    const [validateInput, setValidateInput] = useState("")

    const handleValidate = e => {
        setValidateInput(e.target.value)

        setValidation(e.target.value.length >= 2 ? "passed" : "not-passed")
    }

    const items = [
        {
            title: "Text input",
            content: (
                <Grid col={2} gap="xs">
                    <Input id="text" placeholder="Input text" onChange={handleInputs} value={inputs.text} />
                    <Input
                        id="textDisabled"
                        placeholder="Input disabled"
                        disabled
                        onChange={handleInputs}
                        value={inputs.textDisabled}
                    />
                    <Input
                        id="textValidate"
                        placeholder="Input validate"
                        validation="not-passed"
                        onChange={handleInputs}
                        value={inputs.textValidate}
                    />
                    <Input
                        id="textIcon"
                        placeholder="Input text"
                        fajnyIcon="mail-solid"
                        onChange={handleInputs}
                        value={inputs.textIcon}
                    />
                </Grid>
            ),
            code: 'const [inputs, setInputs] = useState({\n    text: "",\n    textDisabled: "",\n    textValidate: "",\n    textIcon: "",\n})\n\nconst handleInputs = (e) =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\n<Input id="text" placeholder="Input text" onChange={handleInputs} value={inputs.text} />\n<Input id="textDisabled" placeholder="Input disabled" disabled onChange={handleInputs} value={inputs.textDisabled} />\n<Input id="textValidate" placeholder="Input validate" validation="not-passed" onChange={handleInputs} value={inputs.textValidate} />\n<Input id="textIcon" placeholder="Input text" fajnyIcon="mail-solid" onChange={handleInputs} value={inputs.textIcon} />',
        },
        {
            title: "Text input with label and helpers",
            content: (
                <Grid col={2} gap="xs">
                    <Input
                        id="helpers"
                        placeholder="Input text"
                        label="Label"
                        helper="Helper"
                        helperBottom="Helper bottom"
                        onChange={handleInputs}
                        value={inputs.helpers}
                    />
                </Grid>
            ),
            code: 'const [inputs, setInputs] = useState({\n    helpers: "",\n})\n\nconst handleInputs = e =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\n<Input\n    id="helpers"\n    placeholder="Input text"\n    label="Label"\n    helper="Helper"\n    helperBottom="Helper bottom"\n    onChange={handleInputs}\n    value={inputs.helpers}\n/>',
        },
        {
            title: "Text input with validation",
            content: (
                <Grid col={2} gap="xs">
                    <Input
                        id="input-validate"
                        label="Input with validation"
                        helperBottom="To pass, the value should be minimum 2 characters long"
                        onChange={handleValidate}
                        value={validateInput}
                        validation={validation}
                    />
                </Grid>
            ),
            code: 'const [validation, setValidation] = useState("not-passed")\nconst [validateInput, setValidateInput] = useState("")\n\nconst handleValidate = (e) => {\n    setValidateInput(e.target.value);\n    setValidation(e.target.value.length >= 2 ? "passed" : "not-passed");\n}\n\n<Input\n    id="inputValidate"\n    label="Input with validation"\n    helperBottom="To pass, the value should be minimum 2 characters long"\n    onChange={handleValidate}\n    value={validateInput}\n    validation={validation}\n/>',
        },
        {
            title: "Text input with counter",
            content: (
                <Grid col={2} gap="xs">
                    <Input
                        id="counter"
                        label="Input with counter"
                        onChange={handleInputs}
                        value={inputs.counter}
                        counter
                        maxLength={24}
                    />
                </Grid>
            ),
            code: 'const [inputs, setInputs] = useState({\n    counter: "",\n})\n\nconst handleInputs = e =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\n<Input\n    id="counter"\n    label="Input with counter"\n    onChange={handleInputs}\n    value={inputs.counter}\n    counter\n    maxLength={24}\n/>',
        },
        {
            title: "Password input",
            content: (
                <Grid col={2} gap="xs">
                    <Input id="password" password value={inputs.password} onChange={handleInputs} />

                    <Input
                        id="passwordIcon"
                        password
                        value={inputs.passwordIcon}
                        onChange={handleInputs}
                        fajnyIconHidePassword="eye-solid"
                        fajnyIconShowPassword="eye-slash-solid"
                    />
                </Grid>
            ),
            code: 'const [inputs, setInputs] = useState({\n    password: "Password",\n    passwordIcon: "Password",\n})\n\nconst handleInputs = (e) =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\n<Input id="password"\n    password\n    value={inputs.password}\n    onChange={handleInputs}\n/>\n\n<Input\n    id="passwordIcon"\n    password\n    value={inputs.passwordIcon}\n    onChange={handleInputs}\n    fajnyIconHidePassword="eye-solid"\n    fajnyIconShowPassword="eye-slash-solid"\n/>',
        },
        {
            title: "File input",
            content: (
                <Grid col={2} gap="xs">
                    <Input id="file" type="file" value={inputs.file} onChange={handleInputs} />
                    <Input id="fileDisabled" type="file" disabled value={inputs.fileDisabled} onChange={handleInputs} />
                </Grid>
            ),
            code: 'const [inputs, setInputs] = useState({\n    file: "",\n    fileDisabled: "",\n})\n\nconst handleInputs = e =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\n<Input id="file" type="file" value={inputs.file} onChange={handleInputs} />\n<Input id="fileDisabled" type="file" disabled value={inputs.fileDisabled} onChange={handleInputs} />',
        },
        {
            title: "Url input",
            content: (
                <Grid col={2} gap="xs">
                    <Input id="url" placeholder="Url" type="url" onChange={handleInputs} value={inputs.url} />
                </Grid>
            ),
            code: 'const [inputs, setInputs] = useState({\n    url: "",\n})\n\nconst handleInputs = e =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\n<Input id="url" placeholder="Url" type="url" onChange={handleInputs} value={inputs.url} />',
        },
        {
            title: "Calendar input",
            content: (
                <Grid col={2} gap="xs">
                    <Input id="calendar" type="date" onChange={handleInputs} value={inputs.calendar} />
                    <Input
                        id="calendarLocal"
                        type="datetime-local"
                        onChange={handleInputs}
                        value={inputs.calendarLocal}
                    />
                </Grid>
            ),
            code: 'const [inputs, setInputs] = useState({\n    calendar: "",\n    calendarLocal: "",\n})\n\nconst handleInputs = e =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\n<Input id="calendar" type="date" onChange={handleInputs} value={inputs.calendar} />\n<Input id="calendarLocal" type="datetime-local" onChange={handleInputs} value={inputs.calendarLocal} />',
        },
        {
            title: "Time input",
            content: (
                <Grid col={2} gap="xs">
                    <Input id="time" type="time" onChange={handleInputs} value={inputs.time} />
                </Grid>
            ),
            code: 'const [inputs, setInputs] = useState({\n    time: "",\n})\n\nconst handleInputs = e =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\n<Input id="time" type="time" onChange={handleInputs} value={inputs.time} />',
        },
        {
            title: "Search input",
            content: (
                <Grid col={2} gap="xs">
                    <Input
                        id="searchEmpty"
                        type="search"
                        placeholder="Search"
                        onChange={handleInputs}
                        value={inputs.searchEmpty}
                        clearSearch={clearSearchEmpty}
                    />

                    <Input
                        id="search"
                        type="search"
                        placeholder="Search"
                        onChange={handleInputs}
                        value={inputs.search}
                        clearSearch={clearSearch}
                    />
                </Grid>
            ),
            code: 'const [inputs, setInputs] = useState({\n    searchEmpty: "",\n    search: "Search",\n})\n\nconst handleInputs = e =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\nconst clearSearch = () =>\n    setInputs({\n        ...inputs,\n        search: "",\n    })\n\nconst clearSearchEmpty = () =>\n    setInputs({\n        ...inputs,\n        searchEmpty: "",\n    })\n\n<Input\n    id="searchEmpty"\n    type="search"\n    placeholder="Search"\n    onChange={handleInputs}\n    value={inputs.searchEmpty}\n    clearSearch={clearSearchEmpty}\n/>\n\n<Input\n    id="search"\n    type="search"\n    placeholder="Search"\n    onChange={handleInputs}\n    value={inputs.search}\n    clearSearch={clearSearch}\n/>',
        },
        {
            title: "Select",
            content: (
                <Grid col={2} gap="xs">
                    <Input id="select" type="select" onChange={handleInputs} value={inputs.select}>
                        <option value="option">Option</option>
                    </Input>
                </Grid>
            ),
            code: 'const [inputs, setInputs] = useState({\n    select: "option",\n})\n\nconst handleInputs = e =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\n<Input id="select" type="select" onChange={handleInputs} value={inputs.select}>\n    <option value="option">Option</option>\n</Input>',
        },
        {
            title: "Textarea",
            content: (
                <Grid col={2} gap="xs">
                    <Input
                        type="textarea"
                        id="textarea"
                        onChange={handleInputs}
                        value={inputs.textarea}
                        placeholder="Textarea"
                    />

                    <Input
                        type="textarea"
                        id="textareaDisabled"
                        onChange={handleInputs}
                        value={inputs.textareaDisabled}
                        placeholder="Textarea"
                        disabled
                    />
                </Grid>
            ),
            code: 'const [inputs, setInputs] = useState({\n    textarea: "",\n    textareaDisabled: "",\n})\n\nconst handleInputs = e =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\n<Input\n    type="textarea"\n    id="textarea"\n    onChange={handleInputs}\n    value={inputs.textarea}\n    placeholder="Textarea"\n/>\n\n<Input\n    type="textarea"\n    id="textareaDisabled"\n    onChange={handleInputs}\n    value={inputs.textareaDisabled}\n    placeholder="Textarea"\n    disabled\n/>',
        },
    ]

    const propsItems = [
        {
            name: "id",
            type: "String",
            example: "input",
            required: "Yes",
        },
        {
            name: "value",
            type: "String or Number",
            example: "inputs.email",
            required: "Yes",
        },
        {
            name: "label",
            type: "String",
            example: "Email",
        },
        {
            name: "helper",
            type: "String",
            example: "Enter a valid email address",
        },
        {
            name: "helperBottom",
            type: "String",
            example: "Your password should be at least 6 characters long",
        },
        {
            name: "counter",
            type: "Boolean",
        },
        {
            name: "maxLength",
            type: "Number",
            example: "140",
        },
        {
            name: "validation",
            type: "String",
            example: "passed",
            possible: commonProps.validationInput,
        },
        {
            name: "type",
            type: "String",
            example: "email",
            possible:
                '"color" | "date" | "datetime-local" | "email" | "file" | "month" | "number" | "password" | "search" | "tel" | "text" | "time" | "url" | "week" | "textarea" | "select"',
            default: "text",
        },
        {
            name: "password",
            type: "Boolean",
        },
        {
            name: "textHidePassword",
            type: "String",
            example: "Cacher",
            default: "Hide",
        },
        {
            name: "textShowPassword",
            type: "String",
            example: "Montrer",
            default: "Show",
        },
        {
            name: "iconShowPassword",
            type: "String",
            example: "eye-slash",
        },
        {
            name: "iconHidePassword",
            type: "String",
            example: "eye",
        },
        {
            name: "fajnyIconShowPassword",
            type: "String",
            example: "eye-slash-solid",
            possible: commonProps.fajnyIcons,
        },
        {
            name: "fajnyIconHidePassword",
            type: "String",
            example: "eye-solid",
            possible: commonProps.fajnyIcons,
        },
        {
            name: "icon",
            type: "String",
            example: "mail",
        },
        {
            name: "iconValidationPassed",
            type: "String",
            example: "check",
        },
        {
            name: "iconValidationNotPassed",
            type: "String",
            example: "close",
        },
        {
            name: "iconCalendar",
            type: "String",
            example: "calendar",
        },
        {
            name: "iconClock",
            type: "String",
            example: "clock",
        },
        {
            name: "iconClear",
            type: "String",
            example: "close-circle",
        },
        {
            name: "iconSelect",
            type: "String",
            example: "chevron-down",
        },
        {
            name: "fajnyIcon",
            type: "String",
            example: "user-solid",
            possible: commonProps.fajnyIcons,
        },
        {
            name: "fajnyIconValidationPassed",
            type: "String",
            example: "check-solid",
            possible: commonProps.fajnyIcons,
            default: "check-circle-solid",
        },
        {
            name: "fajnyIconValidationNotPassed",
            type: "String",
            example: "close-regular",
            possible: commonProps.fajnyIcons,
            default: "close-circle-solid",
        },
        {
            name: "fajnyIconCalendar",
            type: "String",
            example: "calendar-check-solid",
            possible: commonProps.fajnyIcons,
            default: "calendar-solid",
        },
        {
            name: "fajnyIconClock",
            type: "String",
            example: "clock-full-solid",
            possible: commonProps.fajnyIcons,
            default: "clock-solid",
        },
        {
            name: "fajnyIconClear",
            type: "String",
            example: "close-regular",
            possible: commonProps.fajnyIcons,
            default: "close-solid",
        },
        {
            name: "fajnyIconSelect",
            type: "String",
            example: "chevron-up-down-solid",
            possible: commonProps.fajnyIcons,
            default: "chevron-down-solid",
        },
        {
            name: "clearSearch",
            type: "Function",
            example: "-",
            required: (
                <>
                    Yes for <code>&lt;Input type="search" /&gt;</code>
                </>
            ),
        },
    ]

    return (
        <ComponentPage propsItems={propsItems}>
            <DemoItem demo={items[0]} />
            <DemoItem demo={items[1]} />
            <DemoItem demo={items[2]} />
            <DemoItem demo={items[3]} />
            <DemoItem demo={items[4]} />
            <DemoItem demo={items[5]} />
            <DemoItem demo={items[6]} />
            <DemoItem demo={items[7]} />
            <DemoItem demo={items[8]} />
            <DemoItem demo={items[9]} />
            <DemoItem demo={items[10]} />
            <DemoItem demo={items[11]} />
        </ComponentPage>
    )
}

export default InputPage
